import { connect } from 'react-redux';
import {
  clearUserStatuses, registerUser, loginUser, getUserData,
} from '../../actions';
import Login from './component';

export const mapStateToProps = state => (
  {
    loginError: state.user.authError,
    loginSuccess: state.user.authSuccess,
    authenticated: state.user.authenticated,
    surveyComplete: state.survey.done,
  }
);

export default connect(mapStateToProps, {
  clearUserStatuses, registerUser, loginUser, getUserData,
})(Login);
